import { useCallback, useEffect, useState } from 'react';

import { useDispatch } from 'react-redux';

// import ApiClient from 'api/axiosClient';
import Button from 'common-ui/button';
import CustomDatePicker from 'common-ui/customDatePicker';
import { AsyncSelect } from 'common-ui/select';
import dayjs from 'dayjs';
import {
  getLeadSources, // getOffers,
  // getWorkflowStatusesByPrivilege,
} from 'features/sales/salesActions';
import { generateOptions } from 'utils';

import { ButtonWrapper, FilterContainer, FilterWrapper, SelectWrapper } from './Filter.styles';
import { useReportSearchParams } from './useSearchData';

const getFilterCount = (searchData) => {
  const filterKeys = ['period', 'endDate', 'leadSourceId', 'statusId', 'offerId', 'creatorId'];

  return filterKeys.reduce((count, key) => {
    const value = searchData[key];
    if (key === 'startDate' || key === 'endDate') {
      return count + (value ? 1 : 0);
    }
    return count + (value !== null && value !== undefined && value !== '' ? 1 : 0);
  }, 0);
};

const Filter = () => {
  const dispatch = useDispatch();
  const [showFilter, setShowFilter] = useState(false);
  const [leadSources, setLeadSources] = useState([]);
  // const [offers, setOffers] = useState([]);
  // const [users, setUsers] = useState([]);
  // const [leadStatuses, setLeadStatuses] = useState([]);
  const { searchData, setReportSearchData } = useReportSearchParams();
  const searchCount = getFilterCount(searchData);

  const handleClickShowHideSearch = () => {
    setShowFilter(!showFilter);
  };

  const handleLoadLeadSources = useCallback(
    async (search = '') => {
      try {
        const params = { limit: 10000 };
        if (search) params.search = search;

        const response = await dispatch(getLeadSources(params)).unwrap();
        const options = generateOptions(response.leadSources || []);
        setLeadSources(options);
        return options;
      } catch (error) {
        return [];
      }
    },
    [dispatch]
  );

  // const handleLoadOffers = useCallback(
  //   async (search = '') => {
  //     try {
  //       const params = { limit: 10000 };
  //       if (search) params.search = search;

  //       const response = await dispatch(getOffers(params)).unwrap();
  //       const options = generateOptions(response.offers || []);
  //       setOffers(options);
  //       return options;
  //     } catch (error) {
  //       return [];
  //     }
  //   },
  //   [dispatch]
  // );

  // const handleLoadUsers = useCallback(
  //   async (search = '') => {
  //     try {
  //       const params = { limit: 10000 };
  //       if (search) params.search = search;

  //       const response = await ApiClient.get(`/sales/leads/creators?search=${search}`);
  //       const options = generateOptions(response || []);
  //       setUsers(options);
  //       return options;
  //     } catch (error) {
  //       return [];
  //     }
  //   },
  //   [dispatch]
  // );

  // const handleLoadLeadStatuses = useCallback(
  //   async (search = '') => {
  //     try {
  //       const params = search ? { search } : {};
  //       const response = await dispatch(getWorkflowStatusesByPrivilege(params)).unwrap();
  //       const options = generateOptions(response || []);
  //       setLeadStatuses(options);
  //       return options;
  //     } catch (error) {
  //       return [];
  //     }
  //   },
  //   [dispatch]
  // );

  useEffect(() => {}, []);

  useEffect(() => {
    if (searchData.leadSourceId) {
      handleLoadLeadSources();
    }
  }, [searchData.leadSourceId]);
  // useEffect(() => {
  //   if (searchData.statusId) {
  //     handleLoadLeadStatuses();
  //   }
  // }, [searchData.statusId]);

  // useEffect(() => {
  //   if (searchData.offerId) {
  //     handleLoadOffers();
  //   }
  // }, [searchData.offerId]);

  // useEffect(() => {
  //   if (searchData.creatorId) {
  //     handleLoadUsers();
  //   }
  // }, [searchData.creatorId]);

  return (
    <FilterContainer>
      <ButtonWrapper>
        <Button
          outlined
          onClick={handleClickShowHideSearch}
          className="action-button"
          active={searchCount > 0}
          variant="filter"
        >
          Filter{searchCount > 0 ? ` (${searchCount})` : ''}
        </Button>
      </ButtonWrapper>
      {showFilter && (
        <FilterWrapper>
          {/* <SelectWrapper>
            <AsyncSelect
              minHeight="38px"
              maxHeight="38px"
              label="Period"
              defaultOptions={[
                { label: 'Daily', value: 'daily' },
                { label: 'Weekly', value: 'weekly' },
                { label: 'Monthly', value: 'monthly' },
              ]}
              value={
                searchData.period
                  ? {
                      label:
                        searchData.period === 'daily'
                          ? 'Daily'
                          : searchData.period === 'weekly'
                            ? 'Weekly'
                            : 'Monthly',
                      value: searchData.period,
                    }
                  : null
              }
              isClearable
              onChange={(option) => setReportSearchData({ period: option?.value || null })}
            />
          </SelectWrapper> */}
          <SelectWrapper>
            <CustomDatePicker
              label="Date Range"
              placeholder="Select start date"
              value={searchData.startDate ? dayjs(searchData.startDate) : null}
              onChange={(date) => setReportSearchData({ startDate: date })}
              disableFuture
              maxDate={searchData.endDate ? dayjs(searchData.endDate) : null}
              clearable={false}
            />
          </SelectWrapper>
          <SelectWrapper>
            <CustomDatePicker
              label="‎"
              placeholder="Select end date"
              disableFuture
              onChange={(date) => setReportSearchData({ endDate: date })}
              minDate={searchData.startDate ? dayjs(searchData.startDate) : null}
              clearable
            />
          </SelectWrapper>
          <SelectWrapper>
            <AsyncSelect
              label="Lead Source"
              placeholder="Lead source"
              minHeight="38px"
              loadOptions={handleLoadLeadSources}
              onMenuOpen={handleLoadLeadSources}
              maxHeight="38px"
              defaultOptions={leadSources}
              value={
                searchData.leadSourceId
                  ? leadSources.find((source) => source.value === searchData.leadSourceId)
                  : null
              }
              onChange={(option) =>
                setReportSearchData({ leadSourceId: option?.value || null })
              }
              isClearable
            />
          </SelectWrapper>
          {/* <SelectWrapper>
            <AsyncSelect
              minHeight="38px"
              maxHeight="38px"
              label="Status"
              placeholder="Lead Status"
              loadOptions={handleLoadLeadStatuses}
              onMenuOpen={handleLoadLeadStatuses}
              defaultOptions={leadStatuses}
              value={
                searchData.statusId
                  ? leadStatuses.find((status) => status.value === searchData.statusId)
                  : null
              }
              onChange={(option) => setReportSearchData({ statusId: option?.value || null })}
              isClearable
            />
          </SelectWrapper> */}
          {/* <SelectWrapper>
            <AsyncSelect
              label="Offer"
              minHeight="38px"
              maxHeight="38px"
              placeholder="Offer"
              loadOptions={handleLoadOffers}
              onMenuOpen={handleLoadOffers}
              defaultOptions={offers}
              value={
                searchData.offerId
                  ? offers.find((offer) => offer.value === searchData.offerId)
                  : null
              }
              onChange={(option) => setReportSearchData({ offerId: option?.value || null })}
              isClearable
            />
          </SelectWrapper> */}
          {/* <SelectWrapper>
            <AsyncSelect
              label="Lead Creator"
              placeholder="Lead Creator"
              loadOptions={handleLoadUsers}
              minHeight="38px"
              maxHeight="38px"
              onMenuOpen={handleLoadUsers}
              defaultOptions={users}
              value={
                searchData.creatorId
                  ? users.find((user) => user.value === searchData.creatorId)
                  : null
              }
              onChange={(option) => setReportSearchData({ creatorId: option?.value || null })}
              isClearable
            />
          </SelectWrapper> */}
        </FilterWrapper>
      )}
    </FilterContainer>
  );
};

export default Filter;
